// extracted by mini-css-extract-plugin
export default {"entry-card":"EnterOnDeviceModal__entry-card__qbMNZ","entryCard":"EnterOnDeviceModal__entry-card__qbMNZ"};